import React from 'react'
import { Form } from 'react-bootstrap'
const AddStoreItem = () => {
  return (
    <div className='m-1 px-2 py-5'
	style={{ 
		backgroundColor: 'whitesmoke',
		height: '99vh'
	 }}
	>
		<h4><b className=" mb-5">Add New New Store Item </b></h4> 
      <div className="card">
		<div className="card-body">
			<form action="" id="newUser">
				<input type="hidden" name="id" />
				<div className="row">
					<div className="col-md-6 border-right">
						<b className="text-muted">Item Details</b>
						<div className="form-group">
							<label for="" className="control-label">Name</label>
							<input type="text" name="name" className="form-control form-control-sm" required />
						</div>
						<div class="form-group">
							<label className="control-label">Cost Price per pack (i.e purchase Price)</label>
							<input type="email" class="form-control form-control-sm" name="packCostPrice" required />
						</div>
                        <div class="form-group">
							<label className="control-label">Price per pack (i.e Selling price)</label>
							<input type="email" class="form-control form-control-sm" name="packPrice" required />
						</div>
						<div className="form-group">
							<label for="" className="control-label">Cost Price Per Card (i.e Estimated Purchase price)</label>
							<input type="text" name="cardCostPrice" className="form-control form-control-sm" required />
						</div>
						<div className="form-group">
							<label className="control-label">Price Per Card (i.e Selling price)</label>
							<input type="text" className="form-control form-control-sm" name="cardPrice"  />
							
						</div>
						<div className="form-group">
							<label className="control-label"> Total No of Packs  </label>
							<input type="text" className="form-control form-control-sm" name="packTotal" />
							
						</div>
                        <div className="form-group">
							<label className="control-label"> Total No of Cards Per Pack  </label>
							<input type="text" className="form-control form-control-sm" name="cardTotal" />
							
						</div>
					</div>
					<div className="col-md-6">
					<b className="text-muted">Other Details </b>
						
                    <div className="form-group">
							<label className="control-label"> Usage  </label>
							<input type="text" className="form-control form-control-sm" name="usage" />
							
						</div>
                        <div className="form-group">
							<label className="control-label"> Dosage   </label>
							<input type="text" className="form-control form-control-sm" name="dosage"
                            placeholder='prescription for children and adults etc.'
                            />
							
						</div>
                        <div className="form-group">
							<label className="label control-label">shelf location No. </label>
							<input type="text" className="form-control form-control-sm" name="location" />
						</div>
						<div className="form-group">
							<label className="label control-label">Expiration Date</label>
							<input type="date" className="form-control form-control-sm" name="expiration" />
							<small id="pass_match" data-status=''></small>
						</div>
                        <div className="form-group">
							<label for="" className="control-label">Category</label>
							<Form.Select size='sm' name="type" id="type" className="form-control">
								<option value="3" >Select Item Category </option>
								<option value="3" >Oral </option>
								<option value="2" >Others </option>
							</Form.Select>
							<small><i></i></small>
						</div>
					</div>
				</div>
				<hr />
				<div className='row justify-content-center'>
                    <div className="col-lg-6 col-md-6 col-sm-8 col-xs-10 col-xxs-12 text-right d-flex justify-content-center ">
                        {/* <input type='submit' className="btn btn-color mr-2" id="submit-btn"
                        
                        value="Save" /> */}
                        <button className="btn btn-danger btn-lg" >
                            Cancel
                        </button>
                        <button className="btn btn-dark ms-2">
                            Save
                        </button> 
                        
                    </div>
                </div>
			</form>
		</div>
	</div>
    </div>
  )
}

export default AddStoreItem